export const formatNotificationsCount = (value: number) =>
  value > 99 ? "99+" : value;
